module.exports = __webpack_public_path__ + "img/trash_check.e9ff2441.png";